import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {MediaPictureService} from "../../../services/media-picture.service";

const resolutions = {
  small: '150x100',
  normal: '300x200',
  large: '450x300'
} as const;

const defaultPictures = {
  flights: "817659b5-8202-4691-991b-985b05f2c48c",
} as const;

@Component({
  selector: 'offer-image',
  template: `
    <ng-container *ngIf="mediaKey && mediaPictureService.getMediaUrl(mediaKey) as pictureLink">
      <div *ngIf="!highlighted" class="offer-card-image">
        <img class="offer-card-image-main-not-eva" src="{{pictureLink}}/{{this.resolution}}" [alt]="alt" loading="lazy">
      </div>
      <div *ngIf="highlighted" class="offer-card-highlighted-image" [ngStyle]="{background: 'url(' + pictureLink + '/400x400)'}"></div>
    </ng-container>
  `,
  styleUrls: ['./offer-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferImageComponent implements OnInit {
  @Input() mediaKey: string;
  @Input() alt: string;
  @Input() highlighted: boolean = false;
  @Input() size: 'small' | 'normal' | 'large' = 'normal';
  @Input() product: string;

  resolution: string;

  constructor(public mediaPictureService: MediaPictureService) { }

  ngOnInit(): void {
    this.resolution = resolutions[this.size];
    this.mediaKey = this.mediaKey || defaultPictures[this.product];
  }
}
